import type { CSSProperties } from "react";

export const DEFAULT_PROFILE_PICTURE_PATH =
  "/assets/brand/MISC_Brandmark_Secondary.png";

const CUSTOM_UPLOAD_PATH = "/profile-pictures/";

/** User-uploaded photos are stored in blob storage under profile-pictures/. */
export function isCustomProfilePicture(
  profilePicture?: string | null
): boolean {
  return (profilePicture ?? "")
    .trim()
    .toLowerCase()
    .includes(CUSTOM_UPLOAD_PATH);
}

export function isDefaultProfilePicture(
  profilePicture?: string | null
): boolean {
  return !isCustomProfilePicture(profilePicture);
}

export function resolveProfilePictureUrl(
  profilePicture?: string | null
): string {
  return isDefaultProfilePicture(profilePicture)
    ? DEFAULT_PROFILE_PICTURE_PATH
    : profilePicture!.trim();
}

const defaultAvatarContainer: CSSProperties = {
  backgroundColor: "#ffffff",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
};

/** Centered inside the white circle; inset avoids clipping the M points. */
const defaultAvatarImage: CSSProperties = {
  width: "67%",
  height: "67%",
  objectFit: "contain",
  display: "block",
};

const customAvatarImage: CSSProperties = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
};

export function getProfileAvatarContainerStyle(
  profilePicture?: string | null
): CSSProperties {
  return isDefaultProfilePicture(profilePicture) ? defaultAvatarContainer : {};
}

export function getProfileAvatarImageStyle(
  profilePicture?: string | null
): CSSProperties {
  return isDefaultProfilePicture(profilePicture)
    ? defaultAvatarImage
    : customAvatarImage;
}

export { customAvatarImage as customProfileAvatarImageStyle };
